import React from "react";
import "./MeetTeamContent.css";
import teamData from "./MeetTeamData.json";

const MeetTeam = () => {
  return (
    <>
      <div className="main-banner">
        <img
          src="images/Home/banner-home.png"
          alt="banner"
          className="banner-img"
        />
      </div>
      <div className="meet-team-container">
        <h2 className="title">Meet the team</h2>

        <div className="FirstRow-section">
          {teamData.FirstRowData.map((person) => (
            <div key={person.name} className="card">
              <a href={`mailto:${person.email}`} class="" target="_blank">
                <img
                  src="images/teamspics/mail.png"
                  alt="mail"
                  className="mail-icon"
                />
              </a>

              <img src={person.img} alt={person.name} className="profile-img" />
              <div className="content-wrap">
                <p className="name">{person.name}</p>
                <p className="designation">{person.Position}</p>
                <p className="designation">{person.designation}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="SecondRow-section">
          {teamData.SecondRowData.map((person) => (
            <div key={person.name} className="card">
              <a href={`mailto:${person.email}`} class="" target="_blank">
                <img
                  src="images/teamspics/mail.png"
                  alt="mail"
                  className="mail-icon"
                />
              </a>
              <img src={person.img} alt={person.name} className="profile-img" />
              <div className="content-wrap">
                <p className="name">{person.name}</p>
                <p className="designation">{person.Position}</p>
                <p className="designation">{person.designation}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="region-wrapper">
          <div className="first-wrap">
            <div className="inner-wrap">
              <h3 className="americaheading">America</h3>
              {teamData.regions.Americas.map((person) => (
                <div className="region-div">
                  <div key={person.name} className="region-card">
                    <a href={`mailto:${person.email}`} class="" target="_blank">
                      <img
                        src="images/teamspics/mail.png"
                        alt="mail"
                        className="mail-icon"
                      />
                    </a>
                    <img
                      src={person.img}
                      alt={person.name}
                      className="profile-img"
                    />
                    <div className="content-wrap">
                      <p className="name">{person.name}</p>
                      <p className="designation">{person.Position}</p>
                      <p className="designation">{person.designation}</p>
                      <p className="designation">{person.market}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="inner-wrap">
              <h3 className="EMEAheading">EMEA</h3>
              {teamData.regions.EMEA.map((person) => (
                <div className="region-div">
                  <div key={person.name} className="region-card">
                    <a href={`mailto:${person.email}`} class="" target="_blank">
                      <img
                        src="images/teamspics/mail.png"
                        alt="mail"
                        className="mail-icon"
                      />
                    </a>
                    <img
                      src={person.img}
                      alt={person.name}
                      className="profile-img"
                    />
                    <div className="content-wrap">
                      <p className="name">{person.name}</p>
                      <p className="designation">{person.Position}</p>
                      <p className="designation">{person.designation}</p>
                      <p className="designation">{person.market}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="inner-wrap">
              <h3 className="philiheading">Philippines</h3>
              {teamData.regions.Philippines.map((person) => (
                <div className="region-div">
                  <div key={person.name} className="region-card">
                    <a href={`mailto:${person.email}`} class="" target="_blank">
                      <img
                        src="images/teamspics/mail.png"
                        alt="mail"
                        className="mail-icon"
                      />
                    </a>
                    <img
                      src={person.img}
                      alt={person.name}
                      className="profile-img"
                    />
                    <div className="content-wrap">
                      <p className="name">{person.name}</p>
                      <p className="designation">{person.Position}</p>
                      <p className="designation">{person.designation}</p>
                      <p className="designation">{person.market}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="inner-wrap">
            <h3 className="apacheading">APAC</h3>
            <div className="new-group">
              <div className="toprow">
                {teamData.regions.APAC.TopRow.map((person) => (
                  <div className="Apac-wrap">
                    <a href={`mailto:${person.email}`} class="" target="_blank">
                      <img
                        src="images/teamspics/mail.png"
                        alt="mail"
                        className="mail-icon1"
                      />
                    </a>
                    <div key={person.name} className="region-card">
                      <img
                        src={person.img}
                        alt={person.name}
                        className="profile-img"
                      />
                      <div className="content-wrap">
                        <p className="name">{person.name}</p>
                        <p className="designation">{person.Position}</p>
                        <p className="designation">{person.designation}</p>
                        <p className="designation">{person.market}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="belowrow">
                {teamData.regions.APAC.BelowRow.map((person) => (
                  <div className="Apac-wrap">
                    <a href={`mailto:${person.email}`} class="" target="_blank">
                      <img
                        src="images/teamspics/mail.png"
                        alt="mail"
                        className="mail-icon2"
                      />
                    </a>
                    <div key={person.name} className="region-card">
                      <img
                        src={person.img}
                        alt={person.name}
                        className="profile-img"
                      />
                      <div className="content-wrap">
                        <p className="name">{person.name}</p>
                        <p className="designation">{person.Position}</p>
                        <p className="designation">{person.designation}</p>
                        <p className="designation">{person.market}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MeetTeam;
